export const emptyStringToZero = (value: number, originalValue: string): number =>
  originalValue === '' ? 0 : value

export const emptyStringToUndefined = (
  value: number,
  originalValue: string,
): number | undefined => (originalValue === '' ? undefined : value)
